import React from 'react';
import Head from 'next/head';
import styled from 'styled-components';
import Header from '@components/DreamToReality/FacilityTour/Header';
import Section from '@components/DreamToReality/FacilityTour/Section';
import CTA from '@components/DreamToReality/FacilityTour/CTA';
import data from '@components/DreamToReality/FacilityTour/FacilityTourData';
import Wrapper from '@components/DreamToReality/FacilityTour/Wrapper';
import { getSiteUrl } from '@utils/config';

const FacilityTourWrapper = styled.div`
  font-family: 'acumin-pro', sans-serif;
  font-size: 12px;
`;

const FacilityTourPadded = styled.div`
  padding: 80px 25px;
  max-width: 1450px;
  margin: 0 auto;

  @media (max-width: 970px) {
    padding: 25px 20px;
  }

  @media (max-width: 767px) {
    padding: 25px 0px;
  }
`;

const isOdd = (x) => x % 2 !== 0;

const FacilityTour = () => {
  return (
    <Wrapper>
      <Head>
        <title>Interactive Facility Tour | Clayton Homes</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=5, minimum-scale=1"
        />
        <meta name="referrer" content="always" />
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta
          property="og:image"
          content={`${getSiteUrl(
            '/public-assets/images/facility-tour/cover-poster.png'
          )}`}
        />
      </Head>
      <FacilityTourWrapper>
        <Header />
        <FacilityTourPadded>
          {data.map((section, i) => {
            const sectionData = (
              <Section
                alt={isOdd(i)}
                body={section.body}
                header={section.header}
                imageUrl={section.imageUrl}
                matterportUrl={section.matterportUrl}
                videoUrl={section.videoUrl}
                mobileVideoUrl={section.mobileVideoUrl}
                posterUrl={section.posterUrl}
                title={section.title}
                gaLabel={section.gaLabel}
                key={section.id}
              />
            );

            return sectionData;
          })}
          <CTA />
        </FacilityTourPadded>
      </FacilityTourWrapper>
    </Wrapper>
  );
};

export default FacilityTour;
